import Dragger from '@/components/common/Dragger'
import PlayButton from '@/components/common/PlayButton.tsx'
import { addDraggingAudioClip } from '@/features/clips/domain/use-cases/add-dragging-audio-clip.ts'
import type { SoundEffect } from '@/features/sound-effect/domain/models/sound-effect'
import { formatSecondsToMinutesSeconds } from '@/utils/formatters'
import { type FC, useCallback } from 'react'
import { TrackType } from '@/shared/store/tracks.store.tsx'
import { getAudioBufferFromAudioUrl } from '@/utils/get-audio-buffer-from-audio-url.ts'

interface SoundEffectBoxProps {
  effect: SoundEffect
}

const SoundEffectBox: FC<SoundEffectBoxProps> = ({
  effect: { id, name, duration, description, url },
}) => {
  const fetchSound = useCallback(async () => {
    return await getAudioBufferFromAudioUrl(url)
  }, [url])

  const handleDragStart = useCallback(async () => {
    void addDraggingAudioClip(
      id,
      name,
      duration,
      TrackType.SoundEffects,
      fetchSound,
      url
    )
  }, [id, name, duration, url, fetchSound])

  return (
    <Dragger onDragStart={handleDragStart}>
      <div className="flex w-full max-w-[452px] flex-col items-start justify-start gap-3 rounded-r-sm bg-zinc-700 p-4 shadow-[0px_0px_8px_-2px_rgba(0,0,0,0.20)]">
        <div className="flex w-full items-center justify-between gap-2">
          <p className="max-w-[326px] truncate text-lg font-semibold leading-7 text-white">
            {name}
          </p>
          <div className="flex items-center gap-2">
            <div className="text-right text-sm font-normal leading-tight text-neutral-400">
              {duration && formatSecondsToMinutesSeconds(duration)}
            </div>
            <PlayButton soundId={id} fetchBuffer={fetchSound} />
          </div>
        </div>
        {description && (
          <p className="line-clamp-2 text-xs font-normal leading-tight text-zinc-300">
            {description}
          </p>
        )}
      </div>
    </Dragger>
  )
}

export default SoundEffectBox
